<template>
    <div class="learn-item" @click="enterLearnItem">
        <div class="learn-item-img">
            <slot name="learn-item-img"></slot>
            <p class="opacity"></p>
        </div>
        <div class="laern-item-text">
            <slot name="learn-item-text"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        //进入学习课程
        enterLearnItem(){
            console.log("进入学习课程");
        }
    }
}
</script>

<style lang="less" scoped>
.learn-item{
    margin: 0 0 10px 15px;
    width: 216px;
    height: 142px;
    border: solid 1px #d2d2d2;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .learn-item-img{
        height: 106px;
        position: relative;
        >img,.opacity{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;

        }
        .opacity{
            z-index: 3;
            background: rgba(0,0,0,.43);
        }
    }
    .laern-item-text{
        flex: 1;
        display: flex;
        align-items: center;
        min-width: 0;
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
    }
}
</style>
